import {
  DISMISS_ERROR,
  FETCH_SECTIONS_FAILURE,
  FETCH_SECTIONS_REQUEST,
  FETCH_SECTIONS_SUCCESS,
  FETCH_VIDEOS_FAILURE,
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
  FOCUS_SECTION,
  FOCUS_POSITION
} from '../actions/youtube'

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  sectionIds: [],
  sectionsById: {},
  focusedSection: '',
  focusedPosition: {}
}

const youtubeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DISMISS_ERROR:
      return {
        ...INITIAL_STATE
      }

    case FETCH_SECTIONS_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: ''
      }
    case FETCH_SECTIONS_SUCCESS:
      const newSectionIds = []
      const newSectionsById = {}
      const newFocusedPosition = {}
      action.payload.sections.forEach(section => {
        newSectionIds.push(section.id)
        newSectionsById[section.id] = {
          ...section,
          isReady: false,
          isFetching: false,
          hasError: false,
          errorMessage: '',
          videos: []
        }
        newFocusedPosition[section.id] = 0
      })
      return {
        ...state,
        isReady: true,
        sectionIds: newSectionIds,
        sectionsById: newSectionsById,
        focusedPosition: newFocusedPosition
      }
    case FETCH_SECTIONS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage: action.payload.message
      }

    case FETCH_VIDEOS_REQUEST:
      return {
        ...state,
        sectionsById: {
          ...state.sectionsById,
          [action.payload.sectionId]: {
            ...state.sectionsById[action.payload.sectionId],
            isReady: false,
            isFetching: true,
            hasError: false,
            errorMessage: ''
          }
        }
      }
    case FETCH_VIDEOS_SUCCESS:
      return {
        ...state,
        sectionsById: {
          ...state.sectionsById,
          [action.payload.sectionId]: {
            ...state.sectionsById[action.payload.sectionId],
            isReady: true,
            isFetching: false,
            videos: action.payload.videos
          }
        }
      }
    case FETCH_VIDEOS_FAILURE:
      return {
        ...state,
        sectionsById: {
          ...state.sectionsById,
          [action.meta.sectionId]: {
            ...state.sectionsById[action.meta.sectionId],
            isReady: true,
            isFetching: false,
            hasError: true,
            errorMessage: action.payload.message
          }
        }
      }

    case FOCUS_SECTION:
      return {
        ...state,
        focusedSection: action.payload.sectionId
      }

    case FOCUS_POSITION:
      return {
        ...state,
        focusedSection: action.payload.sectionId,
        focusedPosition: {
          ...state.focusedPosition,
          [action.payload.sectionId]: action.payload.position
        }
      }

    default:
      return state
  }
}

export default youtubeReducer
